module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "alertanimation"
    }
  }, [(_vm.isVisible) ? _c('div', {
    staticClass: "alert"
  }, [_c('img', {
    attrs: {
      "src": "/images/alert.svg"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "medium c-dark h7 upcase"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "regular c-dgrey h7"
  }, [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.hasCallback) ? _c('button', {
    staticClass: "medium c-dgrey upcase h7",
    on: {
      "click": _vm.hide
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.$t("cancel")) + "    \n\t\t")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "medium c-accent upcase",
    class: _vm.font,
    on: {
      "click": _vm.hideAndCallback
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.hasCallback ? 'ok' : 'ok') + "\n\t\t")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-000aea6c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/elements/Alert.vue
// module id = 617
// module chunks = 0